import {
  Button,
  Grid,
  TextField,
  makeStyles,
} from "@material-ui/core";
import React, { useState, } from 'react';
import { create } from '../../../../../services/modalities.service';
import {
  ConcludeButtonContainer,
  Header,
} from './styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw"
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    borderRadius: 25,
    minHeight: 50,
  },
  spacer: {
    marginBottom: 20
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50
  },
  titleModal: {
    color: '#031795',
    fontWeight: 'bold',
    fontSize: '20px'
  },
}));

const AddNewModalityModal = ({
  onSuccess,
  setModalStatus,
  t,
  onError,
}) => {
  const classes = useStyles();

  const [modalityName, setModalityName] = useState('');

  const handleCreateModality = async () => {
    const modality = {
      name: modalityName,
      enabled: true,
    };

    const { error, message } = await create(modality);

    if (error) {
      onError(message.response.data.errors[0] || t("menu.modalities.link.addNewModalityError") );
      setModalStatus(false);

      return;
    };

    onSuccess();
    setModalStatus(false);
  };

  return (
    <>
      <div >
        <Header>
          <div>
            <span style={{ float: 'right', cursor: 'pointer' }} onClick={() => { setModalStatus(false) }}>[X] Fechar</span>

            <span className={classes.titleModal}>{t("menu.modalities.link.addNewModality")}</span>
          </div>
        </Header>

        <Grid container spacing={3}>
          <Grid item lg={12} xs={12}>
            <TextField
              name="modalityName"
              id="modalityName"
              onChange={(e) => setModalityName(e.target.value)}
              value={modalityName}
              label={t("slots.modality")}
              fullWidth
              required
              autoComplete="nope"
              error={modalityName ? false : true}
            />
          </Grid>
        </Grid>

        <ConcludeButtonContainer>
          <Button
            className={classes.buttonOutlined}
            variant="outlined"
            onClick={() => setModalStatus(false)}
          >
            {t("forms.committee.buttons.cancel")}
          </Button>
          <Button
            className={classes.button}
            variant="contained"
            onClick={handleCreateModality}
          >
            {t("forms.committee.buttons.save")}
          </Button>
        </ConcludeButtonContainer>
      </div>
    </>
  )
}

export default AddNewModalityModal;
